import { render } from "./SessionData.vue?vue&type=template&id=74c6a145"
import script from "./SessionData.vue?vue&type=script&lang=js"
export * from "./SessionData.vue?vue&type=script&lang=js"

import "./SessionData.vue?vue&type=style&index=0&id=74c6a145&lang=scss"
script.render = render

export default script